if ($('header#header').length) {
    $(function () {
        const flagMap = {
            CZK: 'cz',
            EUR: 'eu',
            HUF: 'hu',
            PLN: 'pl'
        };
        const $button = $('.dropdown button, .navigationActions li a[href="#"]>span:nth-child(1)');
        const currency = $.trim($button.text()).match(/[A-Z]{3}/);
        if (!currency) return;
        const code = currency[0];
        const flag = flagMap[code];
        if (flag) {
            $button.attr('data-currency', code);
            $button.prepend('<img src="/user/documents/upload/sablona-nemazat/currency/' + code + '.svg" alt="' + code + '">')
        }
        $('.dropdown-menu li a, .navigationActions .navigationActions__submenu__item a',).each(function () {
            $(this).prepend('<img src="/user/documents/upload/sablona-nemazat/currency/' + $(this).attr('href').split('=')[1] + '.svg" alt="' + $(this).attr('href').split('=')[1] + '">')
        });
        $('.dropdown-menu li a').each(function () {
            const currencyCode = $(this).attr('href').split('=')[1];
            if (currencyCode === code) {
                $(this).closest('li').remove();
            }
        });
    });

    $('.menu-level-2 img').each(function () {
        ['src', 'data-src'].forEach(attr => {
            let val = $(this).attr(attr);
            if (val && val.includes('/thumb/')) {
                $(this).attr(attr, val.replace('/thumb/', '/orig/'));
            }
        });
    });

    $('a[data-target="login"]').text(translation('ucet'));
    $('a[data-target="login"]:not(.toggle-window)').text(translation('login'));
    $('.responsive-tools').append($('.top-navigation-tools .dropdown').clone());
    $('.responsive-tools').append('<div class="superCart"><i></i><span class="title"></span><span class="price"></span></div>')
    $('.header-top').append($('.responsive-tools'));
    $('#customerLogin form#formLoginIncluded').prepend('<div class="h5">' + translation('prihlaseniLogin') + '</div>')

    $('#customerLogin label[for="loginWidgetEmail"] span').text(translation('jmenoLogin'));
    $('#customerLogin label[for="loginWidgetPassword"] span').text(translation('hesloLogin'));


    $('<span class="close"></span>').appendTo('.login-widget .popup-widget-inner');
    $('nav#navigation img').each(function () {
        $(this).attr('src', $(this).attr('data-src'))
    })
    $(document).on("click", ".login-widget .popup-widget-inner .close", function () {
        $('body').removeClass('user-action-visible login-window-visible')
    })
    $(document).on('click', function (event) {
        var clickedElement = $(event.target);
        if (!(clickedElement.closest('.login-widget').length || clickedElement.is('a[data-target="login"]'))) {
            $('body').removeClass('login-window-visible user-action-visible');
        }
    });
    $(document).ready(function () {
        cloneCart();
    })
    document.addEventListener('ShoptetCartUpdated', function () {
        setTimeout(function () {
            cloneCart();
        }, 301)
    });
    document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        cloneCart();
    });


    $('.popup-widget.cart-widget').prepend('<div class="cartTop"><div class="h5">' + translation('vasKosik') + '</div><span class="close"></span></div>');
    $('.popup-widget.cart-widget .cart-widget-button').prepend('<div class="totalprice"><span class="withvat">' + translation('cartDPH') + ' <span class="price"></span></span><span class="withoutVat">' + translation('cartBezDPH') + ' <span class="price"></span></span></div></div><span class="btn closeCart">' + translation('zpetKNakupovani') + '</span>')
}

$('html').on('click', 'header#header .superCart', function (e) {
    e.stopPropagation();

    const CUSTOM_CLASS = 'cartIsOpen';
    const TARGET = 'cart';

    if (!$('body').hasClass(CUSTOM_CLASS)) {
        const show =
            (TARGET === 'cart' && !$('a[data-target="cart"]').hasClass('full'))
                ? false
                : true;

        shoptet.popups.showPopupWindow(TARGET, show);
        $('body').addClass(CUSTOM_CLASS);
    } else {
        $('body').removeClass(CUSTOM_CLASS);
        $('body').removeClass('cart-widow-visible');
    }
});

$('html').on('click', '.cartTop .close, .closeCart', function () {
    $('body').removeClass('cartIsOpen').removeClass('cart-window-visible')
})

$(document).on('click', function (e) {
    const CLS = 'cartIsOpen';

    if (
        $('body').hasClass(CLS) &&
        !$(e.target).closest('#cart-widget').length &&
        !$(e.target).closest('header#header .superCart').length
    ) {
        $('body').removeClass(CLS);
    }
});


function cloneCart() {
    $('header#header .superCart i').html($('.navigation-buttons a[data-target="cart"] i').text());
    $('header#header .superCart .price').html($('.navigation-buttons a[data-target="cart"] .cart-price').text());
    $('.cart-widget .totalprice .withvat .price').text(Number(getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withVat).ShoptetFormatAsCurrency());
    $('.cart-widget .totalprice .withoutVat .price').text(Number(getShoptetDataLayer('cartInfo').getNoBillingShippingPrice.withoutVat).ShoptetFormatAsCurrency());
    $('.cart-widget .cart-widget-products-inner .cart-widget-product').each(function () {

        $(this).find('.cart-widget-product-price').remove();
        $(this).find('.cart-widget-product-image img').attr('src', $(this).find('.cart-widget-product-image img').attr('data-src').replace('/related/', '/big/'));
        $(this).append('<div class="cart-widget-product-price">' + $(this).find('span[data-testid="cartWidgetProductPrice"]').text() + '</div>')
    })

}